angular.module('gym.pos').controller('PosSaleContactDetailsCtrl', ["$scope", "$stateParams", "$state", "$window", "Sales", "Restangular", "FeatureAvailabilityService", "GTMService", "gym", function($scope, $stateParams, $state, $window, Sales, Restangular, FeatureAvailabilityService, GTMService, gym) {
  var Gym;
  Gym = Restangular.one('gyms', $stateParams.gymId);
  $scope.contactDetails = gym.attributes.gym_contact_detail;
  $scope.contactDetails.pos = 1;
  if (!FeatureAvailabilityService.isAvailable('pos')) {
    $state.go('gym.dashboard');
  }
  GTMService.trackPage('Pos Sales Contact Details');
  return $scope.save = function() {
    var params;
    GTMService.trackPage('Pos Sales Contact Details', 'attempt');
    params = {
      gym_contact_detail_attributes: $scope.contactDetails,
      rootObjectName: 'gym'
    };
    return Gym.doPUT(params, 'update_contact_detail').then(function() {
      var url;
      GTMService.trackPage('Pos Sales Contact Details', 'success');
      url = `${Sales.getRestangularUrl()}/new`;
      $window.open(url, '_self');
      return true;
    }, function(response) {
      GTMService.trackPage('Pos Sales Contact Details', 'error');
      return $scope.contactDetails.errors = response.data.errors;
    });
  };
}]);
